import Form from "vform";
import http from "../axios";
import { func } from "../helpers";

const actions = {
	// Auth actions
	async login({ state }, { form, errors }) {
		try {
			const response = await form.post(state.baseURL + "/login");

			localStorage.setItem("accessToken", response.data.token);
			window.location.href = "/admin/users";
		} catch (error) {
			if (error.response?.data?.message) {
				errors.set("email", error.response.data.message);
			}
		}
	},
	setFormAccessToken() {
		const instance = http.create({
			headers: {
				Authorization: "Bearer " + localStorage.getItem("accessToken"),
			},
		});

		Form.axios = instance;
	},
	logout() {
		localStorage.removeItem("accessToken");
		localStorage.removeItem("userLogged");

		window.location.href = "/login";
	},
	async checkSocialLogin({ state }, params) {
		try {
			const response = await http({
				method: "post",
				url: "check-social-login",
				params: {
					email: params.email,
					token: params.token,
					name: params.name,
				},
			});

			localStorage.setItem("accessToken", response.data.token);
			window.location.href = "/";
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},

	// Helper actions
	copyToClipboard({ state }, data) {
		try {
			navigator.clipboard.writeText(data);
			state.successToast = "Texto copiado al portapapeles";
		} catch (error) {
			state.errorToast = "Error al copiar al portapapeles";
		}
	},
	async downloadFile({ state }, params) {
		try {
			const response = await http({
				method: "post",
				url: params.downloadRoute,
				params: {
					folder: params.folder,
					fileName: params.fileName,
					databaseFileColumn: params.databaseFileColumn,
					databaseFileNameColumn: params.databaseFileNameColumn,
				},
				responseType: !params.isFromDatabase ? "blob" : "",
			});

			let link = null;

			if (params.isFromDatabase) {
				link = document.createElement("a");
				link.href = response.data.fileData;

				link.setAttribute("download", response.data.fileName);

				document.body.appendChild(link);
				link.click();
			} else {
				const fileName =
					response.headers["content-disposition"].split("filename=")[1];

				const url = window.URL.createObjectURL(new Blob([response.data]));

				link = document.createElement("a");
				link.href = url;

				link.setAttribute("download", fileName);

				document.body.appendChild(link);
				link.click();
			}

			state.successToast = "Archivo descargado correctamente";

			if (link != null) {
				link.parentNode.removeChild(link);
			}
		} catch (error) {
			console.error(error);
			state.errorToast = true;

			return error;
		}
	},

	// Registers functions
	async sendForm(
		{ state },
		{ method = "post", form, url, errors, messages = null }
	) {
		try {
			let response;

			state.loading = true;

			if (method == "post") {
				response = await form.post(state.baseURL + url);
			} else if (method == "put") {
				response = await form.put(state.baseURL + url);
			}

			if (messages == null) {
				state.successToast = "Registro guardado correctamente";
			} else {
				if (messages.show) {
					state.successToast = messages.success;
				}
			}

			state.loading = false;
			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			if (error.response?.data) {
				for (const key in error.response.data) {
					errors.set(key, error.response.data[key]);
				}
			}

			return error.response;
		}
	},
	async deleteRegisters({ state }, { url, ids = null }) {
		try {
			state.loading = true;

			const response = await http({
				method: "delete",
				url: url,
				data: {
					ids,
				},
			});

			state.loading = false;
			state.successToast = "Registro/s borrado/s correctamente";

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},
	async getRegisters({ state }, params) {
		try {
			if (
				params.showLoading == null ||
				params.showLoading == undefined ||
				params.showLoading
			) {
				state.datatableDefaults.loading = true;
			}

			let formProps = func.formatFilters("filters");

			let httpParams = {
				...formProps,
			};

			if (
				params.getAll == undefined ||
				(params.getAll != undefined && !params.getAll)
			) {
				httpParams.pagination = {
					currentPage: params?.page != null ? params.page : 0,
					rows:
						params?.rows != null ? params.rows : state.datatableDefaults.rows,
					sortField: state[params.stateVariable].sort.field,
					sortOrder: state[params.stateVariable].sort.order == -1 ? "desc" : "asc",
				};
			}

			if (params.additionalParams != undefined) {
				httpParams = {
					...httpParams,
					...params.additionalParams,
				};
			}

			const response = await http({
				url: params.route,
				params: httpParams,
			});

			state.datatableDefaults.loading = false;
			state[params.stateVariable].list = response.data[params.stateVariable];
			state[params.stateVariable].listTotal = response.data.total;
		} catch (error) {
			console.error(error);

			if (error.response.data.message === "CSRF token mismatch.") {
				location.reload();
			}

			if (
				error.response.data?.message == "User not found" ||
				error.response.data?.message == "Unauthorized" ||
				error.response.data?.message == "Unauthenticated."
			) {
				window.localStorage.clear();
				window.location.href = "/login";
			}

			state.showFormGeneralErrorToast = true;

			return error;
		}
	},

	// Profile
	async getProfileStats({ state }) {
		try {
			state.loading = true;

			const response = await http({
				url: "profile-stats",
			});

			state.loading = false;
			state.profileStats.userLevel = response.data.userLevel;
			state.profileStats.userHasChallenges = response.data.userHasChallenges;
			state.profileStats.challengesSolved = response.data.challengesSolved;
			state.profileStats.challengesStarted = response.data.challengesStarted;
			state.profileStats.myRank = response.data.myRank;

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},
	async updateProfileName({ state }, params) {
		try {
			state.loading = true;

			const response = await http({
				method: "put",
				url: "update-profile-name",
				data: {
					name: params.name,
				},
			});

			state.loading = false;
			state.successToast = "Registro actualizado";

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.name) {
				state.errorToast = error.response.data.name[0];
			}

			return error.response;
		}
	},
	async updateChecked() {
		try {
			await http({
				method: "put",
				url: "update-checked",
			});
		} catch (error) {
			console.error(error);

			return error.response;
		}
	},
	async getPointsHistoric({ state }, params) {
		try {
			state.loading = true;

			const response = await http({
				method: "post",
				url: "get-points-historic",
				data: {
					filter: params.filter,
				},
			});

			state.loading = false;
			state.pointsHistoric = response.data.list;

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.name) {
				state.errorToast = error.response.data.name[0];
			}

			return error.response;
		}
	},

	// Challenges
	async publishChallenge({ state }, { id = null }) {
		try {
			state.loading = true;

			const response = await http({
				method: "put",
				url: "publish-challenge",
				data: {
					id,
				},
			});

			state.loading = false;
			state.successToast = "Registro actualizado";

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},
	async reorderHints({ state }, params) {
		try {
			const response = await http({
				method: "put",
				url: "/hints-reorder",
				params,
			});

			state.successToast = "Orden de las pistas";

			return response;
		} catch (error) {
			console.error(error);
			state.errorToast = true;

			return error;
		}
	},
	async getChallenges({ state }, params) {
		try {
			state.loading = true;

			const response = await http({
				url: "public-challenges",
				params,
			});

			state.loading = false;
			state.challengesList = response.data.challenges;

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},
	async startChallenge({ state }, params) {
		try {
			state.loading = true;

			const response = await http({
				method: "post",
				url: "start-challenge",
				params,
			});

			state.loading = false;
			state.successToast = "Reto comenzado";

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},
	async getChallengeDetails({ state }, params) {
		try {
			state.loading = true;

			const response = await http({
				url: "get-challenge-details",
				params,
			});

			state.loading = false;
			state.challengeDetails = response.data.challenge;

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},
	async quitChallenge({ state }, params) {
		try {
			state.loading = true;

			const response = await http({
				method: "put",
				url: "quit-challenge",
				params,
			});

			state.loading = false;
			state.warningToast = "Reto abandonado";

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},
	async getCreatedUserChallenges({ state }) {
		try {
			state.loading = true;

			const response = await http({
				url: "created-user-challenges",
			});

			state.loading = false;
			state.challengesList = response.data.challenges;

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},
	async challengeSolved({ state }, params) {
		try {
			state.loading = true;

			const response = await http({
				method: "put",
				url: "challenge-solved",
				params,
			});

			state.loading = false;

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},

	// Ads
	async getAdd({ state }) {
		try {
			state.loading = true;

			const response = await http({
				url: "ads",
			});

			state.loading = false;

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},

	// Ranking
	async getRanking({ state }, params) {
		try {
			state.loading = true;

			let httpParams = {};

			httpParams.pagination = {
				currentPage: params?.page != null ? params.page : 0,
				rows: params?.rows != null ? params.rows : state.datatableDefaults.rows,
			};

			const response = await http({
				url: "ranking",
				params: httpParams,
			});

			state.loading = false;
			state.ranking.list = response.data.users;
			state.ranking.listTotal = response.data.total;

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},
	async topThree({ state }) {
		try {
			state.loading = true;

			const response = await http({
				url: "top-three",
			});

			state.loading = false;
			state.ranking.topThree = response.data.users;

			return response;
		} catch (error) {
			console.error(error);

			state.loading = false;

			if (error.response?.data?.message) {
				state.errorToast = error.response.data.message;
			}

			return error.response;
		}
	},

	// Hints
	async discountHint({ state }, params) {
		try {
			const response = await http({
				method: "put",
				url: "discount-hint",
				params,
			});

			state.userLogged.hints = response.data.hints;

			if (state.userLogged.hints == 0) {
				state.warningToast = "No tienes más pistas";
			}
		} catch (error) {
			console.error(error);
		}
	},
	async hintsPrice({ state }, params) {
		try {
			const response = await http({
				url: "hints-price",
				params,
			});

			state.hints_price = response.data.price;
		} catch (error) {
			console.error(error);
		}
	},
	async orderCanceled(context, params) {
		try {
			await http({
				method: "put",
				url: "order-canceled",
				params,
			});
		} catch (error) {
			console.error(error);
		}
	},
	async orderFinished(context, params) {
		try {
			const response = await http({
				method: "put",
				url: "order-finished",
				params,
			});

			return response;
		} catch (error) {
			console.error(error);
		}
	},
	async updateHints(context, params) {
		try {
			const response = await http({
				method: "put",
				url: "update-hints",
				params,
			});

			return response;
		} catch (error) {
			console.error(error);
		}
	},
};

export default actions;
